import { useEffect } from "react";

type CmsHtmlInjectionProps = {
	html?: string | null;
	target: "head" | "body";
};

const executedScripts = new Set<string>();

export function CmsHtmlInjection({ html, target }: CmsHtmlInjectionProps) {
	useEffect(() => {
		if (!html) return;

		const destination = target === "head" ? document.head : document.body;

		const template = document.createElement("template");
		template.innerHTML = html;

		const addedNodes: Node[] = [];

		for (const node of Array.from(template.content.childNodes)) {
			let newNode: Node;

			if (node instanceof HTMLScriptElement) {
				const key = node.src || `${node.type}:${node.textContent ?? ""}`;

				if (executedScripts.has(key)) {
					continue;
				}

				executedScripts.add(key);

				const script = document.createElement("script");

				for (const attribute of node.attributes) {
					script.setAttribute(attribute.name, attribute.value);
				}

				script.textContent = node.textContent;
				newNode = script;
			} else {
				newNode = node.cloneNode(true);
			}

			destination.appendChild(newNode);
			addedNodes.push(newNode);
		}

		return () => {
			addedNodes.forEach((node) => {
				node.parentNode?.removeChild(node);
			});
		};
	}, [html, target]);

	return null;
}
